import { render, staticRenderFns } from "./AnnotationsTab.vue?vue&type=template&id=90a8ade0&scoped=true&"
import script from "./AnnotationsTab.vue?vue&type=script&lang=js&"
export * from "./AnnotationsTab.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationsTab.vue?vue&type=style&index=0&id=90a8ade0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a8ade0",
  null
  
)

export default component.exports